import { createDirectMessagesRecentOutbound } from '../../api/outbound/directMessagesOutbounds';
import { setBugsnagPanelType } from '../../utils/bugsnagUtils';
import { resetActiveConversation, thunkMarkDirectMessagesAsRead } from './directMessagesActions';
import { thunkSetStageDimensions } from './gameDimensionsActions';
import { thunkShowSelfInfo } from './selfDataActions';
import { ensurePanelHasPriority } from './sessionActions';
export const CLEAR_PANELS_STATE = 'CLEAR_PANELS_STATE';
export const SET_PANEL_TYPES = 'SET_PANEL_TYPES';
export const SET_ACTIVE_PANEL = 'SET_ACTIVE_PANEL';
export const ADD_PANEL_UPDATE = 'ADD_PANEL_UPDATE';
export const CLEAR_PANEL_UPDATES = 'CLEAR_PANEL_UPDATES';
export const ADD_PANEL = 'ADD_PANEL';
export const REMOVE_PANEL = 'REMOVE_PANEL';
export const TOGGLE_DEBUG_PANEL = 'TOGGLE_DEBUG_PANEL';
export const SET_NUM_VISIBLE_PANEL_BUTTONS = 'SET_NUM_VISIBLE_PANEL_BUTTONS';
export const SET_SIDE_BETS_PANEL_STATE = 'SET_SIDE_BETS_PANEL_STATE';
export function clearPanelsState() {
    return {
        type: CLEAR_PANELS_STATE
    };
}
function setPanelTypes(panelTypes, canHidePanel) {
    return {
        type: SET_PANEL_TYPES,
        payload: { panelTypes, canHidePanel }
    };
}
export function thunkSetPanelTypes(panelTypes, socketSend, canHidePanel, activePanelType) {
    return function (dispatch) {
        dispatch(setPanelTypes(panelTypes, canHidePanel));
        dispatch(thunkSetActivePanel(activePanelType, socketSend));
    };
}
function setActivePanel(panelType, canActionHidePanel) {
    return {
        type: SET_ACTIVE_PANEL,
        payload: { panelType, canActionHidePanel }
    };
}
function thunkMaybeHandleClosingActivePanel(panelType) {
    return function (dispatch) {
        if (!panelType) {
            // when closing the active panel, close any active conversation in case it's not intuitive that the user would
            // otherwise have to click the 'Back to Conversations List' button:
            dispatch(resetActiveConversation());
        }
    };
}
function thunkMaybeHandleSwitchingPanels(panelType, socketSend) {
    return function (dispatch, getState) {
        const state = getState();
        const currActivePanelType = state.panels.activePanelType;
        if (panelType && panelType !== currActivePanelType) {
            // do any initializations needed for the new active panel (only when switching to the panel from another)
            switch (panelType) {
                case 'self': {
                    dispatch(thunkShowSelfInfo(socketSend));
                    break;
                }
                case 'directMessages': {
                    // fetch recent conversations if not already done:
                    if (!state.directMessages.hasFetchedRecentConversations) {
                        socketSend(createDirectMessagesRecentOutbound());
                    }
                    // if the active conversation received new messages while direct message panel was inactive, mark messages as read when switching to the panel
                    const activeConversation = state.directMessages.activeConversationPlayerId !== undefined
                        ? state.directMessages.conversations.find((conversation) => conversation.playerIdName.id === state.directMessages.activeConversationPlayerId)
                        : undefined;
                    if (activeConversation) {
                        dispatch(thunkMarkDirectMessagesAsRead(activeConversation, socketSend));
                    }
                    break;
                }
            }
        }
    };
}
export function thunkSetActivePanel(panelType, socketSend, canActionHidePanel = false) {
    return function (dispatch, getState) {
        dispatch(thunkMaybeHandleClosingActivePanel(panelType));
        dispatch(thunkMaybeHandleSwitchingPanels(panelType, socketSend));
        dispatch(setActivePanel(panelType, canActionHidePanel));
        if (panelType) {
            const numEnabledPanels = getState().panels.panels.length;
            const numVisiblePanelButtons = getState().panels.numVisiblePanelButtons;
            if (numVisiblePanelButtons) {
                dispatch(ensurePanelHasPriority(panelType, numEnabledPanels, numVisiblePanelButtons));
            }
        }
        if (getState().scene.roomSceneType === 'poker') {
            // maybe resize stage if panel visibility changed:
            const stageDimensions = getState().gameDimensions.stageDimensions;
            if (stageDimensions) {
                dispatch(thunkSetStageDimensions(stageDimensions));
            }
        }
        setBugsnagPanelType(getState().panels.activePanelType);
    };
}
export function addPanelUpdate(panelType) {
    return {
        type: ADD_PANEL_UPDATE,
        payload: panelType
    };
}
export function clearPanelUpdates(panelType) {
    return {
        type: CLEAR_PANEL_UPDATES,
        payload: panelType
    };
}
export function addPanelType(panelState) {
    return {
        type: ADD_PANEL,
        payload: panelState
    };
}
export function removePanel(panelType) {
    return {
        type: REMOVE_PANEL,
        payload: panelType
    };
}
function toggleDebugPanel() {
    return { type: TOGGLE_DEBUG_PANEL };
}
export function thunkToggleDebugPanel(socketSend) {
    return function (dispatch, getState) {
        dispatch(toggleDebugPanel());
        if (getState().panels.panels.find(({ type }) => type === 'debug')) {
            // debug panel was just toggled on, so switch to it:
            dispatch(thunkSetActivePanel('debug', socketSend));
        }
    };
}
export function setNumVisiblePanelButtons(numVisiblePanelButtons) {
    return {
        type: SET_NUM_VISIBLE_PANEL_BUTTONS,
        payload: numVisiblePanelButtons
    };
}
export function setSideBetsPanelState(isEnabled) {
    return {
        type: SET_SIDE_BETS_PANEL_STATE,
        payload: isEnabled
    };
}
